/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AlertUpdate
 */
export interface AlertUpdate {
    /**
     * 
     * @type {string}
     * @memberof AlertUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AlertUpdate
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof AlertUpdate
     */
    level: string;
    /**
     * 
     * @type {boolean}
     * @memberof AlertUpdate
     */
    isOpen: boolean;
}

export function AlertUpdateFromJSON(json: any): AlertUpdate {
    return AlertUpdateFromJSONTyped(json, false);
}

export function AlertUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'message': json['message'],
        'level': json['level'],
        'isOpen': json['is_open'],
    };
}

export function AlertUpdateToJSON(value?: AlertUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'message': value.message,
        'level': value.level,
        'is_open': value.isOpen,
    };
}


